const THEME_KEY = 'siteTheme';

export function clearAuthSession({ preserveTheme = true } = {}) {
  const themePreference = preserveTheme ? localStorage.getItem(THEME_KEY) : null;

  localStorage.clear();
  sessionStorage.clear();

  if (preserveTheme && themePreference) {
    localStorage.setItem(THEME_KEY, themePreference);
  }
}
